<template>
  <div>
    <div class="ls_drawer_main_content">
      <h1 class="item_detail_header" style="margin-bottom: 20px">{{ detail.name }}
        <Tag v-show="detail.default" color="success">По-умолчанию</Tag>
        <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
      </h1>

      <div class="fs-15 color-grey mb-30">
        <!-- CREATED DATE -->
        <Row>
          <Col span="12">
            Дата создания:
          </Col>
          <Col span="12">
            {{ formatDateTime(detail.created_date) }}
          </Col>
        </Row>

        <!-- IIN-->
        <Row>
          <Col span="12">
            ИИН/БИН:
          </Col>
          <Col span="12">
            {{ detail.inn }}
          </Col>
        </Row>

        <!-- PHONE-->
        <Row>
          <Col span="12">
            Телефон:
          </Col>
          <Col span="12">
            {{ detail.phone }}
          </Col>
        </Row>

        <!-- EMAIL-->
        <Row>
          <Col span="12">
            Email:
          </Col>
          <Col span="12">
            {{ detail.email }}
          </Col>
        </Row>

        <!-- ADDRESS LEGAL-->
        <Row>
          <Col span="12">
            Адрес:
          </Col>
          <Col span="12">
            {{ detail.address_legal }}
          </Col>
        </Row>


      </div>


      <Divider dashed="true"><h2>Последние операции</h2></Divider>

      <!-- RECENT OPERATIONS -->
      <div style="text-align: center;">
        <RadioGroup v-model="doc_tab_switch" type="button">
          <Radio :label="doc_tab_switch_labels[0]"></Radio>
          <Radio :label="doc_tab_switch_labels[1]"></Radio>
        </RadioGroup>
      </div>

      <recentProductOrders
        v-if="doc_tab_switch === doc_tab_switch_labels[0]"
        style="min-height: 20%; margin-top: 20px"
        filter_by="supplier"
        :filter_by_id="id"
      ></recentProductOrders>

      <recentMoneyOrders
        v-else
        style="min-height: 20%; margin-top: 20px"
        filter_by="supplier"
        :filter_by_id="id"
      ></recentMoneyOrders>
    </div>
    <div class="ls_drawer_footer" style="margin-top: 50px">
      <Button style="margin-right: 8px" type="primary" @click="cancelAction()"><Icon type="md-close" /></Button>
      <Button style="margin-right: 8px" v-if="display_edit_button" type="info" @click="editAction()"><Icon type="md-create" /></Button>
      <Button v-if="display_delete_button" type="error" @click="removeModal = true" style="float: left; margin-right: 15px"
      ><Icon type="md-trash" />
      </Button>
    </div>



    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данного поставщика?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteAction()">
          Удалить
        </Button>
      </Row>
    </Modal>



    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
  import { BaseDetailData } from "../../base/base_detail.js";
  import recentProductOrders from "../../components/core/recentProductOrders";
  import recentMoneyOrders from "../../components/core/recentMoneyOrders";

  let _app = BaseDetailData();

  _app.data = function() {
    return {
      loading: true,
      detail: {},

        removeModal: false,
        removeId: null,
        footerHide: true,

      //  Additional nested data
      sections: [],
      showAddSectionModal: false,
      formSectionData: {
        name: ""
      },

      doc_tab_switch: "Движение товара",
      doc_tab_switch_labels: ["Движение товара", "Движение денег"],
    };
  };
  _app.components = {
    recentProductOrders,
    recentMoneyOrders
  };
  _app.methods.editAction = function() {
    this.$router.push({
      name: this.item_type + "_edit",
      params: { id: this.id }
    });
  };
  export default _app;
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/apps/supplier/supplierDetail.vue